import { render, staticRenderFns } from "./getMessageList.vue?vue&type=template&id=8b5851f2&scoped=true&lang=pug"
import script from "./getMessageList.vue?vue&type=script&lang=js"
export * from "./getMessageList.vue?vue&type=script&lang=js"
import style0 from "./getMessageList.vue?vue&type=style&index=0&id=8b5851f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5851f2",
  null
  
)

export default component.exports